let routes = [
  {
    path: '/about',
    name: 'Index',
    component: () => import('@/views/system/page/About.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/system/page/Privacy.vue')
  },
  // 鹤壁活动微信支付成功过渡页
  {
    path: '/redirect',
    name: 'redirectUrl',
    component: () => import('@/views/system/page/Redirect.vue')
  }
]

routes = [...routes]

export default routes
